import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { IndeterminatePaginatorComponent } from './indeterminate-paginator.component';

@NgModule({
  declarations: [
    IndeterminatePaginatorComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    McColorModule,
    MatIconModule,
    MatSelectModule
  ],
  exports: [
    IndeterminatePaginatorComponent
  ]
})
export class IndeterminatePaginatorModule { }
